import { render, staticRenderFns } from "./ThePageComponentRecommendedProducts.vue?vue&type=template&id=333b0f95&"
import script from "./ThePageComponentRecommendedProducts.vue?vue&type=script&lang=js&"
export * from "./ThePageComponentRecommendedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333b0f95')) {
      api.createRecord('333b0f95', component.options)
    } else {
      api.reload('333b0f95', component.options)
    }
    module.hot.accept("./ThePageComponentRecommendedProducts.vue?vue&type=template&id=333b0f95&", function () {
      api.rerender('333b0f95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/ThePageComponentRecommendedProducts.vue"
export default component.exports